import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import isBetween from 'dayjs/plugin/isBetween';
import updateLocale from 'dayjs/plugin/updateLocale';

import './sentry';
import router from './router';
import apollo from './apollo';
import theme from './theme';
import AuthProvider from './context/AuthProvider';
import './index.css';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-react-table/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/core/styles/baseline.css';
import '@mantine/core/styles/default-css-variables.css';
import '@mantine/core/styles/global.css';
import '@mantine/core/styles.layer.css';
import 'mantine-datatable/styles.layer.css';
import '@gfazioli/mantine-window/styles.css';
import { UserPortalProvider } from './context/UserPortalContext';
import MobileAppOverlay from './components/MobileAppOverlay';

dayjs.extend(relativeTime);
dayjs.extend(isBetween);
dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
    weekStart: 1,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ApolloProvider client={apollo}>
            <MantineProvider theme={theme}>
                <AuthProvider router={router}>
                    <ModalsProvider>
                        <UserPortalProvider>
                            <Notifications zIndex={100001} />
                            <MobileAppOverlay />
                            <RouterProvider router={router} />
                        </UserPortalProvider>
                    </ModalsProvider>
                </AuthProvider>
            </MantineProvider>
        </ApolloProvider>
    </React.StrictMode>,
);
